import React from "react";
import { StyledUnavailableAllocationToCanadaAlert } from "./index.styled";

export const UnavailableAllocationToCanadaAlert = () => {
  return (
    <StyledUnavailableAllocationToCanadaAlert
      type="error"
      closable
      title="Your allocation is currently unavailable. In addition, only allocation can be used to ship to Canada"
    >
      Please contact customer service about your allocation, or ship to a
      different location.
    </StyledUnavailableAllocationToCanadaAlert>
  );
};
